import { render, staticRenderFns } from "./DepartamentoPessoalQuadroFuncionarios.vue?vue&type=template&id=3d1dc0d2"
import script from "./DepartamentoPessoalQuadroFuncionarios.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalQuadroFuncionarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports